import "./Header.css";
import Button from "../../../../../shared/components/Button/Button";
import Timer from "../../../../../shared/components/Timer/Timer";
import images from "../../../../../utilities/images/images";
import useAppHooks from "../../../../../shared/hooks/useAppHooks";
import { useHistory } from "react-router-dom";

const Header = (props) => {
  const { onSubmit, onExitClick, onTimeUp } = props;
  const { selector } = useAppHooks();
  // const history = useHistory();

  // const handleBackNavigation = () => {
  //   history.push("/TestInstruction");
  // };

  const state = selector((state) => state.examSlice);

  return (
    <div className="header-container">
      <div className="header-left" onClick={onExitClick}>
        <img src={images.new_backarrow} alt="Back" className="back-icon" />
      </div>

      <div className="header-center">
        <Timer duration={state?.paper_duration} onTimeUp={onTimeUp} />
      </div>

      <div className="header-right">
        <Button
          title="Submit"
          variant="outlined"
          color="error"
          onClick={onSubmit}
          accessor="submit-btn"
          className="header-submit-btn"
        />
      </div>
    </div>
  );
};

export default Header;
